import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Pages/Home";
import Coindetail from "./Pages/Coindetail";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "./Redux/action";
import { toast, ToastContainer } from 'react-toastify';
import { Cookies, useCookies } from "react-cookie";

import Config from "./config/config";
import { getCookie, isEmpty, NumberChange, SetToken } from "./Actions/commonFunction";
import { getWishlist, Signon } from "./Actions/v1/user";
import { setAccount, setWishlist } from "./Redux/user.action";
import Exchanges from './Pages/Exchanges';
import Spotmarket from './Pages/Spotmarket';
import Vac from './Pages/Vac';
import Vacverification from './Pages/Vacverification';
import Vacscorecard from "./Pages/vacscorecard";
import Vacsystem from "./Pages/Vacsystem";

function App() {

  const cookies = new Cookies();
  const theme = useSelector((state) => state.theme.theme);
  const dispatch = useDispatch();

  async function checkCookie(cookieName) {
    let cookie = getCookie(cookieName);
    console.log("cookiecookie", cookie);
    if (cookie != "") {
      let getusercookie = getCookie(Config.userCookieName);
      // if (isEmpty(localStorage.registedEmail) || isEmpty(getusercookie)) {
        let Resp = await Signon({ data: cookie });
        console.log("RespResp", Resp?.data);
        // Resp.data = {...Resp.data.data,token : Resp.token}
        // console.log("🚀 ~ checkCookie ~ Resp.data:", Resp.data)
        if (Resp?.status) {
          cookies.removeChangeListener(cookieChangeListener);
          toast.success("Login Successfully");
          localStorage.setItem("registedEmail", Resp?.data?.data.EmailId);
          SetToken(Config.userCookieName, Resp?.data.token);
        let wishlist = await getWishlist({_id : Resp.data?.data._id }) 
          dispatch(setWishlist({
            ...wishlist.data
          }));
          console.log("🚀 ~ checkCookie ~ wishlist:", wishlist)
          dispatch(setAccount({
              Regname: Resp.data?.data.UserName,
              Profile: Resp.data?.data.Profile,
              EmailId: Resp.data?.data.EmailId,
              _id: Resp.data?.data._id
          }));
        } 
    } else {
      if (!isEmpty(localStorage.registedEmail)) {
        localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      console.log("cookie doesnot exist set the cookie again");
    }
  }

  const cookieChangeListener = () => {
    checkCookie(Config.cookiename);
  };

  //Console off for Production
  useEffect(() => {
    if (Config.EnvName == "production") {
      console.log = () => {};
      console.warning = () => {};
      console.info = () => {};
      console.error = () => {};
    }
  }, []);

  useEffect(() => {
    let currTheme = localStorage.getItem("theme");
    console.log("currThemecurrTheme", currTheme);
    dispatch(setTheme(currTheme ? currTheme : "light"));
  }, []);


  useEffect(() => {
    cookies.addChangeListener(cookieChangeListener);
      cookieChangeListener();
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coindetail/:tokenId" element={<Coindetail />} />
          {/* <Route path="/coindetail" element={<Coindetail />} /> */}
          <Route path="/exchanges/:type/:extype" element={<Exchanges />} />
          <Route path="/exchangedetail/:type/:name" element={<Spotmarket />} />
          <Route path="/vac" element={<Vac />} />
          <Route path="/vac-verification" element={<Vacverification />} />
          <Route path="/vac-scorecard" element={<Vacscorecard />} />
          <Route path="/vac-system" element={<Vacsystem />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            className: "fw-600",
            style: {
              textAlign:"center",
              background: "rgb(58 183 27)",
              color: "white",
            },
          },
          error: {
            className: "fw-600",
            style: {
              textAlign:"center",
              background: "#cd1212",
              color: "white",
            },
          },
        }}
      />
    </>
  );
}

export default App;
